__turbopack_context__.v({
  "imgWrapper": "webstory-module-scss-module__PznkVW__imgWrapper",
  "storyImg": "webstory-module-scss-module__PznkVW__storyImg",
  "storyWrapper": "webstory-module-scss-module__PznkVW__storyWrapper",
  "title": "webstory-module-scss-module__PznkVW__title",
  "titleContainer": "webstory-module-scss-module__PznkVW__titleContainer",
});
